module.exports = __webpack_public_path__ + "img/sb14.bf30c4c9.png";